export default __webpack_public_path__ + "static/media/new-remote-mob.94e9d32f.png";